
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexA4zj0eAEYWAvPErxtroXhPb6yhZO3vMQgttORIuKj7kMeta } from "/var/www/cld-nuxt/pages/index.vue?macro=true";
import { default as _91_46_46_46404_93zsG4ovicefGhgRxIszpmCfdjj1XzJOJJgxd3I1EyQT4Meta } from "/var/www/cld-nuxt/pages/[...404].vue?macro=true";
import { default as contact_45usHClmx1Zp0SABIXJFGPr2WxWk0TLfDz0WbQtQpT8q7gsMeta } from "/var/www/cld-nuxt/pages/contact-us.vue?macro=true";
import { default as our_45historyWhaRKO0q07c3M3IL8xzUdRLHQEhmadhbUFflBANzyswMeta } from "/var/www/cld-nuxt/pages/our-history.vue?macro=true";
import { default as cartrn_BQBz6bMkhB9_wdpHpOKyA4hawas_45LJ62C1vnXihsMeta } from "/var/www/cld-nuxt/pages/account/cart.vue?macro=true";
import { default as our_45servicesjfrjGwOhxCygWXbM6FkKxZwCUdV4NKtME8y_45LMXePB0Meta } from "/var/www/cld-nuxt/pages/our-services.vue?macro=true";
import { default as profileFxBRfoL8dowLu62jQVjVoDoXA_45elezFPHkY1U3mab7EMeta } from "/var/www/cld-nuxt/pages/user/profile.vue?macro=true";
import { default as loginzAD8JaCyiyhRRzr933WsvBTWj_aNahvOy0IWXzo_45rWoMeta } from "/var/www/cld-nuxt/pages/account/login.vue?macro=true";
import { default as historyiuFT_45aGSflO7hX0y6lrDAsD_45h94A0jaEFm8aRKeHT0QMeta } from "/var/www/cld-nuxt/pages/order/history.vue?macro=true";
import { default as opendocsr7M5GHla8KCOm_Bznc_45f_xrSWcsuP6JAL9Q9sF3FOdoMeta } from "/var/www/cld-nuxt/pages/order/opendocs.vue?macro=true";
import { default as searcho5PsC2s0AZj_45WaKWk_HLwrYz0nfDq3miL5qoxYwQuWEMeta } from "/var/www/cld-nuxt/pages/products/search.vue?macro=true";
import { default as backordersntp3zgH9LDlqsGmYVN4DtBsdX9ILRVUmcpBpoC3SyJkMeta } from "/var/www/cld-nuxt/pages/order/backorders.vue?macro=true";
import { default as pricedown_46client3SZxWvQM5wpyBjE8kxSpMy4giuqOpyjwFUXbEzh9Ae0Meta } from "/var/www/cld-nuxt/pages/pricedown.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/var/www/cld-nuxt/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as pre_45signupu8bci0WTJVTKNyjYaOS7ewXcOR40G7afkqq32ndhucgMeta } from "/var/www/cld-nuxt/pages/account/pre-signup.vue?macro=true";
import { default as deliverablesGC90Ib29xAjKQM_45jT4E0GmMek8_Wa_45gBMcL3BCDWc7oMeta } from "/var/www/cld-nuxt/pages/order/deliverables.vue?macro=true";
import { default as searchhistory4STSHO2QncEmdpDBLUXcyGGtpH6xIgwK9EgzePk6DK0Meta } from "/var/www/cld-nuxt/pages/order/searchhistory.vue?macro=true";
import { default as cartmanagementKxscphu6V_e126uxscDcVkTSsN_KE9_FUm4RzX9i9DAMeta } from "/var/www/cld-nuxt/pages/order/cartmanagement.vue?macro=true";
import { default as _91name_93KjqxnErrOO2Z7eMqmDjWiSjUQ08w98EKJMSzNtyM_455sMeta } from "/var/www/cld-nuxt/pages/products/[id]/[name].vue?macro=true";
import { default as dropship_45historyGC3U0c_45Jxe5nXvU4decrJc37oNOzHUvEo9xBqydkwy8Meta } from "/var/www/cld-nuxt/pages/order/dropship-history.vue?macro=true";
import { default as _91id_93_45M1nb1RtI5YCKUAdsinRpUBJxCwQ28Nig7JCBsZnCMQMeta } from "/var/www/cld-nuxt/pages/account/post-signup/[id].vue?macro=true";
import { default as unavailableDeliveries9lfRXBoulxMQOc2wHguptFIZgk7UlP2P3HbSCHN5LGEMeta } from "/var/www/cld-nuxt/pages/order/unavailableDeliveries.vue?macro=true";
import { default as downloadhistory_46clienttfJVPQhqfdzPi0CT1qYgltdAh_p8SdB_45e8Kt737DrxwMeta } from "/var/www/cld-nuxt/pages/order/downloadhistory.client.vue?macro=true";
import { default as indexp4sr2a7_45R9WUznF0LDfjCyTACN_45MDvRIEmTWvLJakWQMeta } from "/var/www/cld-nuxt/pages/account/forgot-password/index.vue?macro=true";
import { default as indexrgaPai0AXEa3xlSTFFynND_mHYQrmnDXblo0Sq4qa0MMeta } from "/var/www/cld-nuxt/pages/account/forgot-password/[id]/index.vue?macro=true";
import { default as component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7MMeta } from "/var/www/cld-nuxt/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7M } from "/var/www/cld-nuxt/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/index.vue")
  },
  {
    name: "index___sv",
    path: "/sv",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/index.vue")
  },
  {
    name: "404___fr",
    path: "/fr/:404(.*)*",
    component: () => import("/var/www/cld-nuxt/pages/[...404].vue")
  },
  {
    name: "404___en",
    path: "/en/:404(.*)*",
    component: () => import("/var/www/cld-nuxt/pages/[...404].vue")
  },
  {
    name: "404___de",
    path: "/de/:404(.*)*",
    component: () => import("/var/www/cld-nuxt/pages/[...404].vue")
  },
  {
    name: "404___nl",
    path: "/nl/:404(.*)*",
    component: () => import("/var/www/cld-nuxt/pages/[...404].vue")
  },
  {
    name: "404___es",
    path: "/es/:404(.*)*",
    component: () => import("/var/www/cld-nuxt/pages/[...404].vue")
  },
  {
    name: "404___sv",
    path: "/sv/:404(.*)*",
    component: () => import("/var/www/cld-nuxt/pages/[...404].vue")
  },
  {
    name: "contact-us___fr",
    path: "/fr/contact-us",
    component: () => import("/var/www/cld-nuxt/pages/contact-us.vue")
  },
  {
    name: "contact-us___en",
    path: "/en/contact-us",
    component: () => import("/var/www/cld-nuxt/pages/contact-us.vue")
  },
  {
    name: "contact-us___de",
    path: "/de/contact-us",
    component: () => import("/var/www/cld-nuxt/pages/contact-us.vue")
  },
  {
    name: "contact-us___nl",
    path: "/nl/contact-us",
    component: () => import("/var/www/cld-nuxt/pages/contact-us.vue")
  },
  {
    name: "contact-us___es",
    path: "/es/contact-us",
    component: () => import("/var/www/cld-nuxt/pages/contact-us.vue")
  },
  {
    name: "contact-us___sv",
    path: "/sv/contact-us",
    component: () => import("/var/www/cld-nuxt/pages/contact-us.vue")
  },
  {
    name: "our-history___fr",
    path: "/fr/our-history",
    component: () => import("/var/www/cld-nuxt/pages/our-history.vue")
  },
  {
    name: "our-history___en",
    path: "/en/our-history",
    component: () => import("/var/www/cld-nuxt/pages/our-history.vue")
  },
  {
    name: "our-history___de",
    path: "/de/our-history",
    component: () => import("/var/www/cld-nuxt/pages/our-history.vue")
  },
  {
    name: "our-history___nl",
    path: "/nl/our-history",
    component: () => import("/var/www/cld-nuxt/pages/our-history.vue")
  },
  {
    name: "our-history___es",
    path: "/es/our-history",
    component: () => import("/var/www/cld-nuxt/pages/our-history.vue")
  },
  {
    name: "our-history___sv",
    path: "/sv/our-history",
    component: () => import("/var/www/cld-nuxt/pages/our-history.vue")
  },
  {
    name: "account-cart___fr",
    path: "/fr/account/cart",
    component: () => import("/var/www/cld-nuxt/pages/account/cart.vue")
  },
  {
    name: "account-cart___en",
    path: "/en/account/cart",
    component: () => import("/var/www/cld-nuxt/pages/account/cart.vue")
  },
  {
    name: "account-cart___de",
    path: "/de/account/cart",
    component: () => import("/var/www/cld-nuxt/pages/account/cart.vue")
  },
  {
    name: "account-cart___nl",
    path: "/nl/account/cart",
    component: () => import("/var/www/cld-nuxt/pages/account/cart.vue")
  },
  {
    name: "account-cart___es",
    path: "/es/account/cart",
    component: () => import("/var/www/cld-nuxt/pages/account/cart.vue")
  },
  {
    name: "account-cart___sv",
    path: "/sv/account/cart",
    component: () => import("/var/www/cld-nuxt/pages/account/cart.vue")
  },
  {
    name: "our-services___fr",
    path: "/fr/our-services",
    component: () => import("/var/www/cld-nuxt/pages/our-services.vue")
  },
  {
    name: "our-services___en",
    path: "/en/our-services",
    component: () => import("/var/www/cld-nuxt/pages/our-services.vue")
  },
  {
    name: "our-services___de",
    path: "/de/our-services",
    component: () => import("/var/www/cld-nuxt/pages/our-services.vue")
  },
  {
    name: "our-services___nl",
    path: "/nl/our-services",
    component: () => import("/var/www/cld-nuxt/pages/our-services.vue")
  },
  {
    name: "our-services___es",
    path: "/es/our-services",
    component: () => import("/var/www/cld-nuxt/pages/our-services.vue")
  },
  {
    name: "our-services___sv",
    path: "/sv/our-services",
    component: () => import("/var/www/cld-nuxt/pages/our-services.vue")
  },
  {
    name: "user-profile___fr",
    path: "/fr/user/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/user/profile.vue")
  },
  {
    name: "user-profile___en",
    path: "/en/user/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/user/profile.vue")
  },
  {
    name: "user-profile___de",
    path: "/de/user/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/user/profile.vue")
  },
  {
    name: "user-profile___nl",
    path: "/nl/user/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/user/profile.vue")
  },
  {
    name: "user-profile___es",
    path: "/es/user/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/user/profile.vue")
  },
  {
    name: "user-profile___sv",
    path: "/sv/user/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/user/profile.vue")
  },
  {
    name: "account-login___fr",
    path: "/fr/account/login",
    meta: loginzAD8JaCyiyhRRzr933WsvBTWj_aNahvOy0IWXzo_45rWoMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/login.vue")
  },
  {
    name: "account-login___en",
    path: "/en/account/login",
    meta: loginzAD8JaCyiyhRRzr933WsvBTWj_aNahvOy0IWXzo_45rWoMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/login.vue")
  },
  {
    name: "account-login___de",
    path: "/de/account/login",
    meta: loginzAD8JaCyiyhRRzr933WsvBTWj_aNahvOy0IWXzo_45rWoMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/login.vue")
  },
  {
    name: "account-login___nl",
    path: "/nl/account/login",
    meta: loginzAD8JaCyiyhRRzr933WsvBTWj_aNahvOy0IWXzo_45rWoMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/login.vue")
  },
  {
    name: "account-login___es",
    path: "/es/account/login",
    meta: loginzAD8JaCyiyhRRzr933WsvBTWj_aNahvOy0IWXzo_45rWoMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/login.vue")
  },
  {
    name: "account-login___sv",
    path: "/sv/account/login",
    meta: loginzAD8JaCyiyhRRzr933WsvBTWj_aNahvOy0IWXzo_45rWoMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/login.vue")
  },
  {
    name: "order-history___fr",
    path: "/fr/order/history",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/history.vue")
  },
  {
    name: "order-history___en",
    path: "/en/order/history",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/history.vue")
  },
  {
    name: "order-history___de",
    path: "/de/order/history",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/history.vue")
  },
  {
    name: "order-history___nl",
    path: "/nl/order/history",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/history.vue")
  },
  {
    name: "order-history___es",
    path: "/es/order/history",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/history.vue")
  },
  {
    name: "order-history___sv",
    path: "/sv/order/history",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/history.vue")
  },
  {
    name: "order-opendocs___fr",
    path: "/fr/order/opendocs",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/opendocs.vue")
  },
  {
    name: "order-opendocs___en",
    path: "/en/order/opendocs",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/opendocs.vue")
  },
  {
    name: "order-opendocs___de",
    path: "/de/order/opendocs",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/opendocs.vue")
  },
  {
    name: "order-opendocs___nl",
    path: "/nl/order/opendocs",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/opendocs.vue")
  },
  {
    name: "order-opendocs___es",
    path: "/es/order/opendocs",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/opendocs.vue")
  },
  {
    name: "order-opendocs___sv",
    path: "/sv/order/opendocs",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/opendocs.vue")
  },
  {
    name: "products-search___fr",
    path: "/fr/products/search",
    meta: { ...(searcho5PsC2s0AZj_45WaKWk_HLwrYz0nfDq3miL5qoxYwQuWEMeta || {}), ...{"middleware":"set-layout"} },
    component: () => import("/var/www/cld-nuxt/pages/products/search.vue")
  },
  {
    name: "products-search___en",
    path: "/en/products/search",
    meta: { ...(searcho5PsC2s0AZj_45WaKWk_HLwrYz0nfDq3miL5qoxYwQuWEMeta || {}), ...{"middleware":"set-layout"} },
    component: () => import("/var/www/cld-nuxt/pages/products/search.vue")
  },
  {
    name: "products-search___de",
    path: "/de/products/search",
    meta: { ...(searcho5PsC2s0AZj_45WaKWk_HLwrYz0nfDq3miL5qoxYwQuWEMeta || {}), ...{"middleware":"set-layout"} },
    component: () => import("/var/www/cld-nuxt/pages/products/search.vue")
  },
  {
    name: "products-search___nl",
    path: "/nl/products/search",
    meta: { ...(searcho5PsC2s0AZj_45WaKWk_HLwrYz0nfDq3miL5qoxYwQuWEMeta || {}), ...{"middleware":"set-layout"} },
    component: () => import("/var/www/cld-nuxt/pages/products/search.vue")
  },
  {
    name: "products-search___es",
    path: "/es/products/search",
    meta: { ...(searcho5PsC2s0AZj_45WaKWk_HLwrYz0nfDq3miL5qoxYwQuWEMeta || {}), ...{"middleware":"set-layout"} },
    component: () => import("/var/www/cld-nuxt/pages/products/search.vue")
  },
  {
    name: "products-search___sv",
    path: "/sv/products/search",
    meta: { ...(searcho5PsC2s0AZj_45WaKWk_HLwrYz0nfDq3miL5qoxYwQuWEMeta || {}), ...{"middleware":"set-layout"} },
    component: () => import("/var/www/cld-nuxt/pages/products/search.vue")
  },
  {
    name: "order-backorders___fr",
    path: "/fr/order/backorders",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/backorders.vue")
  },
  {
    name: "order-backorders___en",
    path: "/en/order/backorders",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/backorders.vue")
  },
  {
    name: "order-backorders___de",
    path: "/de/order/backorders",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/backorders.vue")
  },
  {
    name: "order-backorders___nl",
    path: "/nl/order/backorders",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/backorders.vue")
  },
  {
    name: "order-backorders___es",
    path: "/es/order/backorders",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/backorders.vue")
  },
  {
    name: "order-backorders___sv",
    path: "/sv/order/backorders",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/backorders.vue")
  },
  {
    name: "pricedown___fr",
    path: "/fr/pricedown",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/var/www/cld-nuxt/pages/pricedown.client.vue"))
  },
  {
    name: "pricedown___en",
    path: "/en/pricedown",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/var/www/cld-nuxt/pages/pricedown.client.vue"))
  },
  {
    name: "pricedown___de",
    path: "/de/pricedown",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/var/www/cld-nuxt/pages/pricedown.client.vue"))
  },
  {
    name: "pricedown___nl",
    path: "/nl/pricedown",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/var/www/cld-nuxt/pages/pricedown.client.vue"))
  },
  {
    name: "pricedown___es",
    path: "/es/pricedown",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/var/www/cld-nuxt/pages/pricedown.client.vue"))
  },
  {
    name: "pricedown___sv",
    path: "/sv/pricedown",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/var/www/cld-nuxt/pages/pricedown.client.vue"))
  },
  {
    name: "account-pre-signup___fr",
    path: "/fr/account/pre-signup",
    meta: { ...(pre_45signupu8bci0WTJVTKNyjYaOS7ewXcOR40G7afkqq32ndhucgMeta || {}), ...{"middleware":["redirect-logged-in"]} },
    component: () => import("/var/www/cld-nuxt/pages/account/pre-signup.vue")
  },
  {
    name: "account-pre-signup___en",
    path: "/en/account/pre-signup",
    meta: { ...(pre_45signupu8bci0WTJVTKNyjYaOS7ewXcOR40G7afkqq32ndhucgMeta || {}), ...{"middleware":["redirect-logged-in"]} },
    component: () => import("/var/www/cld-nuxt/pages/account/pre-signup.vue")
  },
  {
    name: "account-pre-signup___de",
    path: "/de/account/pre-signup",
    meta: { ...(pre_45signupu8bci0WTJVTKNyjYaOS7ewXcOR40G7afkqq32ndhucgMeta || {}), ...{"middleware":["redirect-logged-in"]} },
    component: () => import("/var/www/cld-nuxt/pages/account/pre-signup.vue")
  },
  {
    name: "account-pre-signup___nl",
    path: "/nl/account/pre-signup",
    meta: { ...(pre_45signupu8bci0WTJVTKNyjYaOS7ewXcOR40G7afkqq32ndhucgMeta || {}), ...{"middleware":["redirect-logged-in"]} },
    component: () => import("/var/www/cld-nuxt/pages/account/pre-signup.vue")
  },
  {
    name: "account-pre-signup___es",
    path: "/es/account/pre-signup",
    meta: { ...(pre_45signupu8bci0WTJVTKNyjYaOS7ewXcOR40G7afkqq32ndhucgMeta || {}), ...{"middleware":["redirect-logged-in"]} },
    component: () => import("/var/www/cld-nuxt/pages/account/pre-signup.vue")
  },
  {
    name: "account-pre-signup___sv",
    path: "/sv/account/pre-signup",
    meta: { ...(pre_45signupu8bci0WTJVTKNyjYaOS7ewXcOR40G7afkqq32ndhucgMeta || {}), ...{"middleware":["redirect-logged-in"]} },
    component: () => import("/var/www/cld-nuxt/pages/account/pre-signup.vue")
  },
  {
    name: "order-deliverables___fr",
    path: "/fr/order/deliverables",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/deliverables.vue")
  },
  {
    name: "order-deliverables___en",
    path: "/en/order/deliverables",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/deliverables.vue")
  },
  {
    name: "order-deliverables___de",
    path: "/de/order/deliverables",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/deliverables.vue")
  },
  {
    name: "order-deliverables___nl",
    path: "/nl/order/deliverables",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/deliverables.vue")
  },
  {
    name: "order-deliverables___es",
    path: "/es/order/deliverables",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/deliverables.vue")
  },
  {
    name: "order-deliverables___sv",
    path: "/sv/order/deliverables",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/deliverables.vue")
  },
  {
    name: "order-searchhistory___fr",
    path: "/fr/order/searchhistory",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/searchhistory.vue")
  },
  {
    name: "order-searchhistory___en",
    path: "/en/order/searchhistory",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/searchhistory.vue")
  },
  {
    name: "order-searchhistory___de",
    path: "/de/order/searchhistory",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/searchhistory.vue")
  },
  {
    name: "order-searchhistory___nl",
    path: "/nl/order/searchhistory",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/searchhistory.vue")
  },
  {
    name: "order-searchhistory___es",
    path: "/es/order/searchhistory",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/searchhistory.vue")
  },
  {
    name: "order-searchhistory___sv",
    path: "/sv/order/searchhistory",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/searchhistory.vue")
  },
  {
    name: "order-cartmanagement___fr",
    path: "/fr/order/cartmanagement",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/cartmanagement.vue")
  },
  {
    name: "order-cartmanagement___en",
    path: "/en/order/cartmanagement",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/cartmanagement.vue")
  },
  {
    name: "order-cartmanagement___de",
    path: "/de/order/cartmanagement",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/cartmanagement.vue")
  },
  {
    name: "order-cartmanagement___nl",
    path: "/nl/order/cartmanagement",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/cartmanagement.vue")
  },
  {
    name: "order-cartmanagement___es",
    path: "/es/order/cartmanagement",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/cartmanagement.vue")
  },
  {
    name: "order-cartmanagement___sv",
    path: "/sv/order/cartmanagement",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/cartmanagement.vue")
  },
  {
    name: "products-id-name___fr",
    path: "/fr/products/:id()/:name()",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/products/[id]/[name].vue")
  },
  {
    name: "products-id-name___en",
    path: "/en/products/:id()/:name()",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/products/[id]/[name].vue")
  },
  {
    name: "products-id-name___de",
    path: "/de/products/:id()/:name()",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/products/[id]/[name].vue")
  },
  {
    name: "products-id-name___nl",
    path: "/nl/products/:id()/:name()",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/products/[id]/[name].vue")
  },
  {
    name: "products-id-name___es",
    path: "/es/products/:id()/:name()",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/products/[id]/[name].vue")
  },
  {
    name: "products-id-name___sv",
    path: "/sv/products/:id()/:name()",
    meta: {"middleware":"set-layout"},
    component: () => import("/var/www/cld-nuxt/pages/products/[id]/[name].vue")
  },
  {
    name: "order-dropship-history___fr",
    path: "/fr/order/dropship-history",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/dropship-history.vue")
  },
  {
    name: "order-dropship-history___en",
    path: "/en/order/dropship-history",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/dropship-history.vue")
  },
  {
    name: "order-dropship-history___de",
    path: "/de/order/dropship-history",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/dropship-history.vue")
  },
  {
    name: "order-dropship-history___nl",
    path: "/nl/order/dropship-history",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/dropship-history.vue")
  },
  {
    name: "order-dropship-history___es",
    path: "/es/order/dropship-history",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/dropship-history.vue")
  },
  {
    name: "order-dropship-history___sv",
    path: "/sv/order/dropship-history",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/dropship-history.vue")
  },
  {
    name: "account-post-signup-id___fr",
    path: "/fr/account/post-signup/:id()",
    meta: { ...(_91id_93_45M1nb1RtI5YCKUAdsinRpUBJxCwQ28Nig7JCBsZnCMQMeta || {}), ...{"middleware":["redirect-logged-in"]} },
    component: () => import("/var/www/cld-nuxt/pages/account/post-signup/[id].vue")
  },
  {
    name: "account-post-signup-id___en",
    path: "/en/account/post-signup/:id()",
    meta: { ...(_91id_93_45M1nb1RtI5YCKUAdsinRpUBJxCwQ28Nig7JCBsZnCMQMeta || {}), ...{"middleware":["redirect-logged-in"]} },
    component: () => import("/var/www/cld-nuxt/pages/account/post-signup/[id].vue")
  },
  {
    name: "account-post-signup-id___de",
    path: "/de/account/post-signup/:id()",
    meta: { ...(_91id_93_45M1nb1RtI5YCKUAdsinRpUBJxCwQ28Nig7JCBsZnCMQMeta || {}), ...{"middleware":["redirect-logged-in"]} },
    component: () => import("/var/www/cld-nuxt/pages/account/post-signup/[id].vue")
  },
  {
    name: "account-post-signup-id___nl",
    path: "/nl/account/post-signup/:id()",
    meta: { ...(_91id_93_45M1nb1RtI5YCKUAdsinRpUBJxCwQ28Nig7JCBsZnCMQMeta || {}), ...{"middleware":["redirect-logged-in"]} },
    component: () => import("/var/www/cld-nuxt/pages/account/post-signup/[id].vue")
  },
  {
    name: "account-post-signup-id___es",
    path: "/es/account/post-signup/:id()",
    meta: { ...(_91id_93_45M1nb1RtI5YCKUAdsinRpUBJxCwQ28Nig7JCBsZnCMQMeta || {}), ...{"middleware":["redirect-logged-in"]} },
    component: () => import("/var/www/cld-nuxt/pages/account/post-signup/[id].vue")
  },
  {
    name: "account-post-signup-id___sv",
    path: "/sv/account/post-signup/:id()",
    meta: { ...(_91id_93_45M1nb1RtI5YCKUAdsinRpUBJxCwQ28Nig7JCBsZnCMQMeta || {}), ...{"middleware":["redirect-logged-in"]} },
    component: () => import("/var/www/cld-nuxt/pages/account/post-signup/[id].vue")
  },
  {
    name: "order-unavailableDeliveries___fr",
    path: "/fr/order/unavailableDeliveries",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/unavailableDeliveries.vue")
  },
  {
    name: "order-unavailableDeliveries___en",
    path: "/en/order/unavailableDeliveries",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/unavailableDeliveries.vue")
  },
  {
    name: "order-unavailableDeliveries___de",
    path: "/de/order/unavailableDeliveries",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/unavailableDeliveries.vue")
  },
  {
    name: "order-unavailableDeliveries___nl",
    path: "/nl/order/unavailableDeliveries",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/unavailableDeliveries.vue")
  },
  {
    name: "order-unavailableDeliveries___es",
    path: "/es/order/unavailableDeliveries",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/unavailableDeliveries.vue")
  },
  {
    name: "order-unavailableDeliveries___sv",
    path: "/sv/order/unavailableDeliveries",
    meta: {"middleware":["auth"]},
    component: () => import("/var/www/cld-nuxt/pages/order/unavailableDeliveries.vue")
  },
  {
    name: "order-downloadhistory___fr",
    path: "/fr/order/downloadhistory",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/var/www/cld-nuxt/pages/order/downloadhistory.client.vue"))
  },
  {
    name: "order-downloadhistory___en",
    path: "/en/order/downloadhistory",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/var/www/cld-nuxt/pages/order/downloadhistory.client.vue"))
  },
  {
    name: "order-downloadhistory___de",
    path: "/de/order/downloadhistory",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/var/www/cld-nuxt/pages/order/downloadhistory.client.vue"))
  },
  {
    name: "order-downloadhistory___nl",
    path: "/nl/order/downloadhistory",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/var/www/cld-nuxt/pages/order/downloadhistory.client.vue"))
  },
  {
    name: "order-downloadhistory___es",
    path: "/es/order/downloadhistory",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/var/www/cld-nuxt/pages/order/downloadhistory.client.vue"))
  },
  {
    name: "order-downloadhistory___sv",
    path: "/sv/order/downloadhistory",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/var/www/cld-nuxt/pages/order/downloadhistory.client.vue"))
  },
  {
    name: "account-forgot-password___fr",
    path: "/fr/account/forgot-password",
    meta: indexp4sr2a7_45R9WUznF0LDfjCyTACN_45MDvRIEmTWvLJakWQMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/forgot-password/index.vue")
  },
  {
    name: "account-forgot-password___en",
    path: "/en/account/forgot-password",
    meta: indexp4sr2a7_45R9WUznF0LDfjCyTACN_45MDvRIEmTWvLJakWQMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/forgot-password/index.vue")
  },
  {
    name: "account-forgot-password___de",
    path: "/de/account/forgot-password",
    meta: indexp4sr2a7_45R9WUznF0LDfjCyTACN_45MDvRIEmTWvLJakWQMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/forgot-password/index.vue")
  },
  {
    name: "account-forgot-password___nl",
    path: "/nl/account/forgot-password",
    meta: indexp4sr2a7_45R9WUznF0LDfjCyTACN_45MDvRIEmTWvLJakWQMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/forgot-password/index.vue")
  },
  {
    name: "account-forgot-password___es",
    path: "/es/account/forgot-password",
    meta: indexp4sr2a7_45R9WUznF0LDfjCyTACN_45MDvRIEmTWvLJakWQMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/forgot-password/index.vue")
  },
  {
    name: "account-forgot-password___sv",
    path: "/sv/account/forgot-password",
    meta: indexp4sr2a7_45R9WUznF0LDfjCyTACN_45MDvRIEmTWvLJakWQMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/forgot-password/index.vue")
  },
  {
    name: "account-forgot-password-id___fr",
    path: "/fr/account/forgot-password/:id()",
    meta: indexrgaPai0AXEa3xlSTFFynND_mHYQrmnDXblo0Sq4qa0MMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/forgot-password/[id]/index.vue")
  },
  {
    name: "account-forgot-password-id___en",
    path: "/en/account/forgot-password/:id()",
    meta: indexrgaPai0AXEa3xlSTFFynND_mHYQrmnDXblo0Sq4qa0MMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/forgot-password/[id]/index.vue")
  },
  {
    name: "account-forgot-password-id___de",
    path: "/de/account/forgot-password/:id()",
    meta: indexrgaPai0AXEa3xlSTFFynND_mHYQrmnDXblo0Sq4qa0MMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/forgot-password/[id]/index.vue")
  },
  {
    name: "account-forgot-password-id___nl",
    path: "/nl/account/forgot-password/:id()",
    meta: indexrgaPai0AXEa3xlSTFFynND_mHYQrmnDXblo0Sq4qa0MMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/forgot-password/[id]/index.vue")
  },
  {
    name: "account-forgot-password-id___es",
    path: "/es/account/forgot-password/:id()",
    meta: indexrgaPai0AXEa3xlSTFFynND_mHYQrmnDXblo0Sq4qa0MMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/forgot-password/[id]/index.vue")
  },
  {
    name: "account-forgot-password-id___sv",
    path: "/sv/account/forgot-password/:id()",
    meta: indexrgaPai0AXEa3xlSTFFynND_mHYQrmnDXblo0Sq4qa0MMeta || {},
    component: () => import("/var/www/cld-nuxt/pages/account/forgot-password/[id]/index.vue")
  },
  {
    name: component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7MMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7M
  },
  {
    name: component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7MMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7M
  },
  {
    name: component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7MMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7M
  },
  {
    name: component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7MMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7M
  },
  {
    name: component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7MMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7M
  },
  {
    name: component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7MMeta?.name,
    path: "/sv/sitemap.xml",
    component: component_45stubD3fWKbczvfTBIKEIZvhAKcusy4Msa5maA3KkNJdjW7M
  }
]